import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      t="1639473734001"
      className="icon"
      viewBox="0 0 1025 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="2609"
      width="200"
      height="200"
    >
      <path
        d="M511.764499 959.807812c-246.966724 0-447.873312-200.906589-447.873312-447.879312 0-246.966724 200.906589-447.873312 447.873312-447.873312 246.972724 0 447.879312 200.906589 447.879312 447.873312C959.643811 758.901223 758.737223 959.807812 511.764499 959.807812L511.764499 959.807812zM511.764499 128.325376c-211.52262 0-383.603124 172.080504-383.603124 383.603124 0 211.49462 172.081504 383.610124 383.603124 383.610124 211.49462 0 383.610124-172.114504 383.610124-383.610124C895.373623 300.40588 723.259119 128.325376 511.764499 128.325376L511.764499 128.325376zM511.764499 128.325376"
        p-id="2610"
      />
      <path
        d="M556.810631 513.305504l138.331405-136.827401c12.569037-12.409036 12.666037-32.662096 0.254001-45.231133-12.414036-12.575037-32.696096-12.673037-45.236133-0.260001L511.637499 467.977371 375.231099 331.14897c-12.512037-12.505037-32.731096-12.574037-45.237133-0.062-12.510037 12.477037-12.540037 32.725096-0.062 45.236133l136.217399 136.6324-137.340402 135.864398c-12.569037 12.448036-12.668037 32.662096-0.254001 45.237133 6.268018 6.336019 14.493042 9.499028 22.747067 9.499028 8.123024 0 16.250048-3.099009 22.489066-9.245027l137.530403-136.022399 138.647406 139.097408c6.238018 6.267018 14.430042 9.401028 22.650066 9.401028 8.191024 0 16.348048-3.134009 22.586066-9.339027 12.506037-12.477037 12.542037-32.696096 0.064-45.236133L556.810631 513.305504 556.810631 513.305504zM556.810631 513.305504"
        p-id="2611"
      />
    </svg>
  )
}
const ErrorIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
ErrorIcon.defaultProps = {
  width: 15,
  height: 15,
  fill: '#E85347',
}
// 参数类型
ErrorIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default ErrorIcon
